import { render } from "./GalleryCardMiniature.vue?vue&type=template&id=5344fa38&scoped=true"
const script = {}

import "./GalleryCardMiniature.vue?vue&type=style&index=0&id=5344fa38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5344fa38"

export default script